import CurrentTimeWidget from './CurrentTimeWidget';

export default CurrentTimeWidget;
